import {gsap} from "../LibrariesImport";

export default class OptimiseContrast {
    static init() {
        this.items = document.querySelectorAll(".btn-fill, .text-contrast");

        if (this.items.length > 0) {
            this.initOptimiseContrast();
        }
    }

    static initOptimiseContrast() {
        this.items.forEach((item, index) => {
            const backgroundColor = getComputedStyle(item).backgroundColor;
            // Convertir RGB en hexadécimal
            const rgb = backgroundColor.match(/\d+/g).map(Number);
            const hex =
                "#" +
                rgb
                    .map((x) => x.toString(16).padStart(2, "0"))
                    .join("");
            item.style.color = this.getContrastYIQ(hex);
            gsap.to(item, { opacity: 1, duration: 1 });

        });
    }

    static getContrastYIQ(hexColor) {
        hexColor = hexColor.replace("#", "");
        const r = parseInt(hexColor.substring(0, 2), 16);
        const g = parseInt(hexColor.substring(2, 4), 16);
        const b = parseInt(hexColor.substring(4, 6), 16);

        // Formule YIQ pour calculer la luminosité perçue
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? "black" : "white"; // Couleur de texte appropriée
    }
}
